export default __webpack_public_path__ + "static/media/aircare-2.189d93ef.png";